<template>
  <modal
    name="modal-share"
    :width="isMobile ? '90%' : '50%'"
    :height="isMobile ? 240 : 270"
    @before-open="beforeOpen"
  >
    <div class="share-modal">
      <div class="modal-header">
        <div class="icon-close" @click="modalClose" />
      </div>
      <div class="modal-content">
        <h1>{{ $t('share') }}</h1>
        <div class="modal-rrss">
          <div class="rrss-block">
            <div v-if="embed" class="rrss-wrapper" @click="copyToClipboard(embedUrl, 'embed')">
              <div class="icon-incrustar" />
              <div class="rrss-text">{{ $t('embed') }}</div>
            </div>
            <div v-if="copiedEmbed" class="copied-embed-feedback">
              <div class="feedback-wrap">
                {{ $t('copied') }}
              </div>
            </div>
            <ShareNetwork
              network="facebook"
              :url="iframeUrl"
              :title="dataTitle"
              :description="dataTitle"
            >
              <div class="rrss-wrapper">
                <div class="icon-facebook" />
                <div class="rrss-text">Facebook</div>
              </div>
            </ShareNetwork>
            <ShareNetwork
              network="linkedin"
              :title="dataTitle"
              :url="iframeUrl"
            >
              <div class="rrss-wrapper">
                <div class="icon-linkedin" />
                <div class="rrss-text">Linkedin</div>
              </div>
            </ShareNetwork>
            <ShareNetwork
              network="twitter"
              :title="dataTitle"
              :url="iframeUrl"
            >
              <div class="rrss-wrapper">
                <div class="icon-twitter" />
                <div class="rrss-text">X</div>
              </div>
            </ShareNetwork>
            <ShareNetwork
              network="reddit"
              :title="dataTitle"
              :url="iframeUrl"
            >
              <div class="rrss-wrapper">
                <div class="icon-reddit" />
                <div class="rrss-text">Reddit</div>
              </div>
            </ShareNetwork>
          </div>
        </div>
        <div class="iframe-wrapper">
          <div ref="text" class="iframe-text" @click="onTextClick()">{{ iframeUrl }}</div>
          <div class="copy-wrapper" @click="copyToClipboard(iframeUrl, 'link')">
            <div class="icon-link" />
            <div class="copy-button">{{ $t('copy_link') }}</div>
          </div>
        </div>
        <div v-if="copied" class="copied-feedback">
          <div class="feedback-wrap">
            {{ $t('copied') }}
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
/**
 * Renders the modal to share the webpage
 * @example [none]
 */
export default {
  name: 'ModalShare',
  props: {
    /**
     * Function for close the modal
     */
    modalClose: {
      type: Function,
    },
    canShareIframe: {
      type: Boolean,
    },
    dataTitle: {
      type: String,
    }
  },
  data() {
    return {
      url: null,
      copied: false,
      copiedEmbed: false,
      embed: false
    }
  },
  computed: {
    iframeUrl() {
      return this.url
    },
    embedUrl() {
      let parts = this.url.split('/')
      if (parts.indexOf('estad%C3%ADstiques') !== -1)
        parts.splice(parts.indexOf('estad%C3%ADstiques'), 0, "embed")
      else if (parts.indexOf('estad%C3%ADsticas') !== -1)
        parts.splice(parts.indexOf('estad%C3%ADsticas'), 0, "embed")
      else parts.splice(parts.indexOf('statistics'), 0, "embed")
      return parts.join('/')
    }
  },
  watch: {
    copied() {
      if (this.copied) {
        setTimeout(() => {
          this.copied = false
        }, 750)
      }
    },
    copiedEmbed() {
      if (this.copiedEmbed) {
        setTimeout(() => {
          this.copiedEmbed = false
        }, 750)
      }
    },
  },
  methods: {
    /**
     * Copy a text to clipboard
     * @param {String} textToCopy String that we want to copy
     * @public This is a public method
     */
    copyToClipboard(textToCopy, type) {
      navigator.clipboard.writeText(textToCopy)
      if (type === 'link') this.copied = true
      else this.copiedEmbed = true
    },
    onTextClick() {
      this.$refs.text.focus()
      selectElementContents(this.$refs.text)
      this.copyToClipboard(this.iframeUrl, 'link')
    },
    beforeOpen(config) {
      this.url = config.params.url
      if (config.params.embed) {
        this.embed = config.params.embed
      } else this.embed = false
    },
  },
}
function selectElementContents(el) {
  if (window.getSelection && document.createRange) {
    var sel = window.getSelection()
    var range = document.createRange()
    range.selectNodeContents(el)
    sel.removeAllRanges()
    sel.addRange(range)
  } else if (document.selection && document.body.createTextRange) {
    var textRange = document.body.createTextRange()
    textRange.moveToElementText(el)
    textRange.select()
  }
}
</script>

<style lang="stylus" scoped>
.share-modal
  display: flex
  flex-direction: column
  height: 100%
  width: 100%

  .modal-header
    position: relative
    width: 100%

    .icon-close
      m-icon("modal-close", 32, $grey-dark)
      cursor: pointer
      position: absolute
      right: vw(20px)
      top: vw(20px)

  .modal-content
    display: flex
    flex-direction: column
    margin-left: vw(25px)
    margin-right: vw(25px)
    margin-top: vw(15px)
    
    .copied-feedback
      display: flex
      justify-content: center
      position: absolute
      top: vw(185px)
      right: vw(65px)

      .feedback-wrap
        background-color: $grey-dark
        color: white
        padding: vw(5px)
        m-font-size(14, 18)

        &:after
          m-triangle("down", $grey-dark, 6)
          bottom: vw(-5px)
          left: 50%
          transform: translateX(-50%)
          
    .copied-embed-feedback
      display: flex
      justify-content: center
      position: absolute
      top: vw(75px)
      left: vw(30px)
      
      .feedback-wrap
        background-color: $grey-dark
        color: white
        padding: vw(5px)
        m-font-size(14, 18)

        &:after
          m-triangle("down", $grey-dark, 6)
          bottom: vw(-5px)
          left: 50%
          transform: translateX(-50%)

    h1
      m-font-size(26, 34)
      font-weight: 600

    .iframe-wrapper
      margin-top: vw(10px)
      align-items: center
      border: 1px solid $bcn-light-grey
      border-radius: 4px
      display: flex
      flex: 0 0 40px
      justify-content: space-between
      margin: vw(20px) 0 vw(20px)
      height: 30px
      padding: 0 vw(15px)
      position: relative
      width: 100%

      .iframe-text
        width: 100%
        m-font-size(14, 18)
        color: $bcn-grey-3
        font-weight: 400
        overflow-x: auto
        -ms-overflow-style: none
        scrollbar-width: none
        white-space: nowrap
        
      .iframe-text::-webkit-scrollbar
        display: none

      .copy-wrapper
        align-items: center
        width: vw(160px)
        cursor: pointer
        display: flex
        margin-left: 10px
        position: sticky
        right: 0
        top: 0

        .icon-link
          m-icon("link-blue", 22)
          margin-right: vw(8px)

        .copy-button
          m-font-size(15, 19)
          color: $corporate_color

    .modal-rrss
      border-top: 1px solid $light-grey
      padding-top: vw(20px)
      align-items: center
      display: flex
      justify-content: flex-start
      width: 100%
      flex-wrap: wrap

      .mobile &
        align-items: center
        
      .buttons-wrapper
        display: flex
        gap: vw(8px)

      .rrss-block
        display: flex
        gap: vw(20px)
        cursor: pointer

        .rrss-wrapper
          align-items: center
          display: flex
          flex-direction: column
          
          .icon-incrustar
            m-icon("incrustar", 50, #000, false)
            margin-bottom: vw(10px)

            .mobile &
              m-icon("incrustar", 40, #000, false)

          .icon-facebook
            m-icon("facebook", 50, #000, false)
            margin-bottom: vw(10px)

            .mobile &
              m-icon("facebook", 40, #000, false)

          .icon-twitter
            m-icon("x-twitter", 50, #000, false)
            margin-bottom: vw(10px)

            .mobile &
              m-icon("x-twitter", 40, #000, false)

          .icon-linkedin
            m-icon("linkedin", 50, #000, false)
            margin-bottom: vw(10px)

            .mobile &
              m-icon("linkedin", 40, #000, false)

          .icon-reddit
            m-icon("reddit", 50, #000, false)
            margin-bottom: vw(10px)

            .mobile &
              m-icon("reddit", 40, #000, false)

          .rrss-text
            m-font-size(14, 18)
            font-weight: 400

      .button-wrapper
        background-color: black
        border-radius: 5px
        padding: vw(15px) vw(20px)

        .mobile &
          padding: vw(8px) vw(12px)

        span
          m-font-size(20, 24)
          color: #fff
</style>
